module.exports = __webpack_public_path__ + "img/353-5a305b.png";